module.exports = __webpack_public_path__ + "static/media/social-facebook.f42115ce.svg";